<div class="credits">
    <div class="credit">Designed by Arun Varghese</div>
    <div>
        <a (click)="ga.sendAnalyticEvent('view-source', 'credits', 'click')"
            href="{{'Repo' | translate}}" rel="nofollow noopener noreferrer" target="_blank">
            <i class="fab fa-angular"></i>
        </a>
    </div>
</div>
